import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import reducers from './reducers';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: reducers
});

const persister = persistStore(store);

export { store, persister };
